export const SET_QUESTIONS = "SET_QUESTIONS",
  SET_ANSWER = "SET_ANSWER",
  SET_MBTI = "SET_MBTI";